export default __webpack_public_path__ + "static/media/ArrowWhiteIcon.58817d66.svg";